import { ReactNode } from 'react';
import NavItem from './NavItem';

interface NavProps {
  className?: string;
  children: ReactNode;
}

const Nav = ({ className = '', children }: NavProps) => <div className={`nav navbar-nav ${className}`}>{children}</div>;

Nav.Item = NavItem;

export default Nav;
